import React, { useEffect, useState } from 'react'
import OTPInput from 'react-otp-input'
import Handler from '../../../../Helpers/Handler'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { contentLoadingChange } from '../../../../Reducer/componentSlice'

const EmailStage = ({ associateDetails, onVerified }) => {
    const dispatch = useDispatch()

    const [emailData, setEmailData] = useState({ email: "", otp: "" })
    const [otpview, setOtpview] = useState(false)
    const [loading, setLoading] = useState(false)

    const sendOtp = async () => {
        if (!emailData?.email) return toast.error("Invalid Email")
        dispatch(contentLoadingChange(true))
        setLoading(true)
        const response = await Handler({ method: "patch", url: `/admin/client/associate/email/otp/${associateDetails?.associateId}`, data: { email: emailData?.email } })
        if (response?.success) {
            toast.success(response?.data?.message || "OTP Sent")
            setOtpview(true)
        } else {
            toast.error(response?.data?.message || "Failed to send OTP")
        }
        dispatch(contentLoadingChange(false))
        setLoading(false)
    }

    const verifyOtp = async () => {
        if (!emailData?.email) return toast.error("Invalid Email")
        if (!emailData?.otp || emailData?.otp?.length !== 5) return toast.error("Invalid OTP")
        dispatch(contentLoadingChange(true))
        setLoading(true)
        const response = await Handler({ method: "patch", url: `/admin/client/associate/email/verify/${associateDetails?.associateId}`, data: { email: emailData?.email, otp: emailData?.otp } })
        if (response?.success) {
            toast.success(response?.data?.message || "OTP Verified")
            dispatch(contentLoadingChange(false))
            setTimeout(() => {
                setLoading(false)
                onVerified?.()
            }, 1500)
        } else {
            toast.error(response?.data?.message || "OTP verification failed")
            dispatch(contentLoadingChange(false))
            setLoading(false)
        }
    }

    useEffect(() => {
        setEmailData({ email: associateDetails?.email?.emailId || "", otp: "" })
        setOtpview(false)
    }, [associateDetails])

    return (
        <>
            <div className="mb-3">
                <label htmlFor="email" className="form-label">Email address</label>
                <input type="email" className="form-control" disabled={otpview || loading} id="email" autoComplete='off' value={emailData?.email} onChange={(e) => setEmailData((prev) => ({ ...prev, email: e?.target?.value }))} />
            </div>
            {otpview && (
                <div className="mb-5">
                    <label className="form-label">OTP</label>
                    <OTPInput
                        value={emailData?.otp}
                        onChange={(e) => setEmailData((prev) => ({ ...prev, otp: e }))}
                        numInputs={5}
                        renderSeparator={<span className="mx-1"></span>}
                        renderInput={(props) => (
                            <input {...props} disabled={loading} className="form-control text-center mx-1" style={{ width: "45px", height: "45px" }} />
                        )}
                    />
                </div>
            )}
            <div className='text-center my-2'>
                {otpview ? (
                    <button className='btn btn-primary' disabled={loading} onClick={verifyOtp}>Verify Otp</button>
                ) : (
                    <button className='btn btn-primary' disabled={loading} onClick={sendOtp}>Send Otp</button>
                )}
            </div>
        </>
    )
}

export default EmailStage
